import Swal from 'sweetalert2';
import translationService from './translator.service';

export const AlertService = {
    showMessage,
    confirmDialog,
    dataMessage,
    showHTMLPopUp,
    timedButtomMessage
}

window.AlertService = AlertService;

function showMessage(icon = '', text = '') {

    Swal.fire({
        icon: icon,
        text: text,
        confirmButtonColor: '#005496'
    })
}

function timedButtomMessage(text = '') {

    Swal.fire({
        text: text,
        position:'bottom',
        showConfirmButton: false,
        timer: 1500
    })
}

async function confirmDialog(langCode = 'HE', text = '', icon = '', confirmText = '', cancelText = '', ) {

    const translatedData = translationService.getTranslatedData(langCode);
    text = text ? text : translationService.getTranslation(translatedData, 'general.messages.areYouSureDoThisAction');
    icon = icon ? icon : AlertsIconEnum.WARNING;
    confirmText = confirmText ? confirmText : translationService.getTranslation(translatedData, 'general.actions.yes');
    cancelText = cancelText ? cancelText : translationService.getTranslation(translatedData, 'general.actions.no');

    var userResult = await Swal.fire({
        icon: icon,
        text: text,
        showCancelButton: true,
        confirmButtonText: confirmText,
        cancelButtonText: cancelText,
        confirmButtonColor: '#005496',
        cancelButtonColor: '#005496'

    }).then((result) => {
        if (result.isConfirmed) {
            return true;
        } else if (result.dismiss) {
            return false;
        }
    })

    return userResult;
}

async function dataMessage(title = '', text = '', icon = '') {

    Swal.fire({
        icon: icon,
        title: title,
        text: text,
    })
}

function showHTMLPopUp(icon, htmlContent) {
    Swal.fire({
        html: htmlContent,
        icon: icon,
    });
}

export const AlertsIconEnum = {
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info',
    QUESTION: 'question',
}




